import { ChakraProvider } from "@chakra-ui/react";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import "./App.css";
import { DataProvider } from "./CaravanDataContext";
import { ONE_DAY } from "./const";
import reportWebVitals from "./reportWebVitals";
import { FormProvider } from "./SearchFormContext";
import { customTheme } from "./styles/theme";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: ONE_DAY,
      refetchInterval: ONE_DAY,
      refetchOnWindowFocus: false,
    },
  },
});

const localStoragePersister = createSyncStoragePersister({
  storage: window.localStorage,
});

// Persist the query client
persistQueryClient({
  queryClient,
  persister: localStoragePersister,
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <StrictMode>
    <ChakraProvider theme={customTheme}>
      <QueryClientProvider client={queryClient}>
        <DataProvider>
          <FormProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </FormProvider>
        </DataProvider>
      </QueryClientProvider>
    </ChakraProvider>
  </StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
